export default {
    navigationBarTitleText: '优秀设计'
  };
  